const t = "_option_1xtvg_1", o = "_noResult_1xtvg_13", n = {
  option: t,
  noResult: o
};
export {
  n as default,
  o as noResult,
  t as option
};
//# sourceMappingURL=index.es5574.js.map
